/* eslint-disable no-else-return */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

import EquipmentActionCreators from 'actions/EquipmentActionCreators';
import EquipmentStore from '../../../stores/EquipmentStore';
import EquipmentRow from './EquipmentRow';
import Alert from '../../ui/Alert';
import ProTip from '../../ui/ProTip';
import { equipmentTypesMapping } from 'constants/Equipment';

const EQUIPMENT_ID_LENGTH_RANGE = [10, 11];

class BulkEditEquipmentModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func.isRequired,
    equipments: PropTypes.array,
  };

  static defaultProps = {
    show: false,
    equipments: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      equipments: props.equipments.map((e) => ({
        ...e,
        isValid: true,
        error: {},
      })),
      status: '',
      saving: false,
      proTipVisible: true,
    };
  }

  componentDidMount() {
    EquipmentStore.addBulkUpdateChangeListener(
      this.handleBulkUpdateResultChange,
    );
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.equipments, nextProps.equipments)) {
      const equipments = nextProps.equipments.map((e) => ({
        ...e,
        isValid: true,
        error: {},
      }));

      this.setState({ equipments });
    }
  }

  componentWillUnmount() {
    EquipmentStore.removeBulkUpdateChangeListener(
      this.handleBulkUpdateResultChange,
    );
  }

  handleBulkUpdateResultChange = () => {
    const { t } = this.props;
    const result = EquipmentStore.getBulkUpdateResult();

    if (result.successes.length > 0) {
      this.setState(
        {
          status: t('EQUIPMENTS_UPDATED_SUCCESSFULLY'),
        },
        () => {
          setTimeout(() => {
            this.setState({
              status: '',
            });
            this.handleHide();
          }, 4000);
        },
      );
    }
    this.setState({
      saving: false,
    });
  };

  handleClearAll = () => {
    const { equipments: currentEquipments } = this.state;

    const equipments = currentEquipments.map(resetEquipment);

    console.log('here');
    this.setState({
      equipments,
    });
  };

  handleSave = () => {
    this.setState(
      (currentState) => {
        return {
          equipments: this.validate(currentState.equipments),
        };
      },
      () => {
        if (this.state.equipments.every((e) => e.isValid)) {
          EquipmentActionCreators.bulkUpdateEquipments(
            this.transformRequest(this.state.equipments),
          );
        }
      },
    );
  };

  handleHide = () => this.props.onHide();

  handleFieldChange = (id, field, value) => {
    this.setState((currentState) => {
      const { equipments: currentEquipments } = currentState;
      const index = currentEquipments.findIndex((e) => e._id === id);

      const targetEquipment = _.cloneDeep(currentEquipments[index]);
      targetEquipment[field] = value;

      const isPrivateChassisAttributesResetRequired =
        (targetEquipment?._equipmentType !== equipmentTypesMapping.CHASSIS) ||
        (!targetEquipment.is_private)

      if (isPrivateChassisAttributesResetRequired) {
        targetEquipment.is_private = null;
        targetEquipment.chassis_owner = null;
        targetEquipment.chassis_owner_type = null;
      }

      const isChassisOwnerUpdating =
        targetEquipment.chassis_owner_type &&
        targetEquipment.chassis_owner_type === 'cargomatic'

      if (isChassisOwnerUpdating) {
        targetEquipment.chassis_owner = null;
      }

      if (targetEquipment?._equipmentType !== equipmentTypesMapping.CONTAINER) {
        targetEquipment._equipmentSize = null;
        targetEquipment._type = '';
      }

      const equipments = [
        ...currentEquipments.slice(0, index),
        targetEquipment,
        ...currentEquipments.slice(index + 1),
      ];

      return {
        equipments,
      };
    });
  };

  handleDeselect = (id) => {
    this.setState((currentState) => {
      const { equipments: currentEquipments } = currentState;

      const equipments = currentEquipments.filter((e) => e._id !== id);

      return {
        equipments,
      };
    });
  };

  handleApplyToAll = (id) => {
    this.setState((currentState) => {
      const { equipments: currentEquipments } = currentState;

      const index = currentEquipments.findIndex((eq) => eq._id === id);

      const targetEquipment = currentEquipments[index];
      const {
        status,
        _type,
        _equipmentType,
        _equipmentSize,
        is_private,
        chassis_owner,
        chassis_owner_type,
      } = targetEquipment;

      const equipments = currentEquipments.map((eq, i) => {
        let mapped = {
          ...eq,
        };

        if (index === i) {
          return mapped;
        }

        /**
         * Apply all will work only on same assets type
         */
        if (mapped?._equipmentType === targetEquipment?._equipmentType) {
          mapped = {
            ...mapped,
            status,
            _type,
            _equipmentType,
            _equipmentSize,
            is_private,
            chassis_owner,
            chassis_owner_type,
          }
        }

        return mapped;
      });

      return {
        equipments,
      };
    });
  };
  handleCloseTip = () => this.setState({ proTipVisible: false });

  transformRequest(equipments) {
    return equipments.map((eq) => {
      const {
        _type,
        _equipmentSize,
        _equipmentType,
        equipment_id,
        status,
        is_private,
        chassis_owner,
        chassis_owner_type,
      } = eq;

      const chassis_owner_id = (chassis_owner?._id && chassis_owner_type === 'customer') ? chassis_owner._id : null;

      return {
        _id: eq._id,
        updates: {
          _type,
          _equipmentSize,
          _equipmentType,
          equipment_id,
          status,
          is_private,
          chassis_owner_type,
          chassis_owner: chassis_owner_id

        },
      };
    });
  }

  validate(equipments) {
    return equipments.map(this.validateEquipment);
  }

  validateEquipment = (equipment, i) => {
    const error = {};
    const { t } = this.props;

    const {
      equipment_id,
      _equipmentType,
      _equipmentSize,
      _type,
      status,
      is_private,
      chassis_owner,
      chassis_owner_type,
    } = equipment;

    const rowNumber = i + 1;

    if (!equipment_id) {
      error.equipment_id = `${t('EQUIPMENT')} ${rowNumber} - ${t(
        'ENTER_EQUIPMENT_NUMBER',
      )}`;
    } else if (
      _equipmentType !== 'trailer' &&
      !EQUIPMENT_ID_LENGTH_RANGE.includes(equipment_id.length)
    ) {
      error.equipment_id = `${t('EQUIPMENT')} ${rowNumber} - ${t(
        'EQUIPMENT_NUMBER_EXPECTED_LENGTH',
        {
          expectedLengths: EQUIPMENT_ID_LENGTH_RANGE.join(' or '),
        },
      )}`;
    }

    if (!_equipmentType) {
      error._equipmentType = `${t('EQUIPMENT')} ${rowNumber} - ${t(
        'PLEASE_SELECT_ASSET_TYPE',
      )}`;
    } else if (_equipmentType === 'container') {
      if (!_type) {
        error._type = `${t('EQUIPMENT')} ${rowNumber} - ${t(
          'PLEASE_SELECT_EQUIPMENT_TYPE',
        )}`;
      }
      if (!_equipmentSize) {
        error._equipmentSize = `${t('EQUIPMENT')} ${rowNumber} - ${t(
          'SELECT_EQUIPMENT_SIZE',
        )}`;
      }
    }

    if (!status) {
      error.status = `${t('EQUIPMENT')} ${rowNumber} - ${t(
        'PLEASE_SELECT_EQUIPMENT_STATUS',
      )} `;
    }

    const isChassisPrivate = _equipmentType === equipmentTypesMapping.CHASSIS && is_private;
    const requiredChassisOwnerType = isChassisPrivate && !chassis_owner_type;
    const requiredChassisOwner = (chassis_owner_type && chassis_owner_type == 'customer') && !chassis_owner;

    if (requiredChassisOwnerType) {
      error.chassis_owner_type = `${t('EQUIPMENT')} ${rowNumber} - ${t(
        'PLEASE_SELECT_CHASSIS_OWNER',
      )} `;
    }

    if (requiredChassisOwner) {
      error.chassis_owner = `${t('EQUIPMENT')} ${rowNumber} - ${t(
        'PLEASE_SELECT_CUSTOMER',
      )} `;
    }

    return {
      ...equipment,
      error,
      isValid: Object.keys(error).length === 0,
    };
  };

  validateOrderTypes = () => {
    const { equipments } = this.props;

    const orderTypes = _.groupBy(equipments, (e) => {
      if (e.order) {
        const {
          order: { order_type },
        } = e;

        return order_type;
      }
      return null;
    });

    return Object.keys(orderTypes).length === 1;
  };

  renderEquipmentForms = () => {
    const { t } = this.props;
    const { equipments } = this.state;

    if (equipments.length === 0) {
      return <p>Please select the equipments you would like to update</p>;
    }

    return (
      <div className="bg-white shadow-lg p-4 w-full">
        <table className="table">
          <thead>
            <tr className="font-bold text-grey-darker border-solid border-grey-lightest border-b">
              <th>{t('ID')}</th>
              <th>{t('ASSET_TYPE')}</th>
              <th>{t('STATUS')}</th>
              <th>{t('TYPE')}</th>
              <th>{t('SIZE', { count: 2 })}</th>
              <th>{t('PRIVATE')}</th>
              <th>{t('CHASSIS_OWNERSHIP')}</th>
              <th>{t('CUSTOMER')}</th>
              <th>{t('APPLY_TO_ALL')}</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {this.state.equipments.map((equipment) => (
              <EquipmentRow
                key={equipment._id}
                equipment={equipment}
                onApplyToAll={this.handleApplyToAll}
                onFieldChange={this.handleFieldChange}
                onDeselect={this.handleDeselect}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  renderProTip() {
    const { t } = this.props;
    if (!this.state.proTipVisible) {
      return null;
    }

    return (
      <ProTip
        message={t('BULKEDIT_PRO_TIP')}
        className={{ 'mb-4': true }}
        onClose={this.handleCloseTip}
      />
    );
  }
  renderStatus() {
    if (!this.state.status) {
      return null;
    }
    return <Alert type="success" title={this.state.status} />;
  }
  renderValidationErrors() {
    const { t } = this.props;
    let validationHeader = t('CORRECT_ISSUES');
    if (this.state.equipments.every((e) => e.isValid)) {
      return null;
    }
    const flattenedErrors = this.state.equipments.reduce((errorList, eq) => {
      const errors = Object.values(eq.error);
      return errorList.concat(errors);
    }, []);
    return (
      <Alert type="error" title={validationHeader}>
        <ul>
          {flattenedErrors.map((error, i) => (
            <li key={i}>{error}</li>
          ))}
        </ul>
      </Alert>
    );
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        show={this.props.show}
        onHide={this.handleHide}
        backdrop="static"
        dialogClassName="modal-override bg-grey-modal"
        keyboard={false}
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{titleize(t('BULK_EDIT_EQUIPMENT'))}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.proTipVisible && this.renderProTip()}
          {this.renderEquipmentForms()}
        </Modal.Body>
        <Modal.Footer>
          <div className="flex flex-wrap items-start justify-end">
            <div className="mr-4">
              {this.renderStatus()}
              {this.renderValidationErrors()}
            </div>
            <div className="flex">
              <button
                className="button button-hollow-green mr-2"
                disabled={this.state.saving}
                onClick={this.handleClearAll}
              >
                {titleize(t('CLEAR_ALL'))}
              </button>
              <button
                onClick={this.handleSave}
                disabled={this.state.saving}
                className="button button-green mr-2"
              >
                {this.state.saving && (
                  <div className="flex items-center">
                    <i className="fa fa-spin fa-circle-o-notch mr-1" />
                    <span>{titleize(t('SAVING'))}...</span>
                  </div>
                )}
                {!this.state.saving && <span>{titleize(t('SAVE'))}</span>}
              </button>
              <button
                onClick={this.handleHide}
                disabled={this.state.saving}
                className="button button-hollow-green"
              >
                {titleize(t('CLOSE'))}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

function resetEquipment(equipment) {
  return {
    ...equipment,
    _type: '',
    status: null,
    _equipmentType: '',
    _equipmentSize: null,
    is_private: false,
    chassis_owner_type: null,
    chassis_owner: null,
  };
}

export default withTranslation()(BulkEditEquipmentModal);
